import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot} from '@angular/router';
import {AuthService} from './auth.service';
import {NavigationService} from './navigation.service';
import {AuthGuard} from './auth.guard';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable()
export class AuthRequiredGuard implements CanActivate {

  constructor(private Auth: AuthService,
              private Navigation: NavigationService,
              private authGuard: AuthGuard) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.authGuard.canActivate(next, state).pipe(
      map(() => this.Auth.isFullyAuthenticated() || !this.Navigation.handleLogin(false, {returnTo: state.url}))
    );
  }

}
